if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        /* ===== Custom Code Start (Redirect to Cart if already converted) ===== */
        if (this.submitButton.dataset.converted === "true") {
          window.location.href = window.routes?.cart_url || '/cart';
          return;
        }
        /* ===== Custom Code End ===== */
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
              // Show add to cart popup
              this.showAddToCartPopup(response);
              /* ===== Custom Code Start (Update button to "View Cart") ===== */
              if (this.submitButton && this.submitButton.id !== 'ProductSubmitButton-quick-buy-drawer') {
                this.submitButton.dataset.converted = "true";
                if (this.submitButtonText) this.submitButtonText.textContent = "View Cart";
                this.submitButton.classList.remove("button--primary");
                this.submitButton.classList.add("button--secondary");
              }
              /* ===== Custom Code End ===== */
              // --- ADD YOUR SCROLL CODE HERE ---
              const addonCont = document.querySelector('.paired-section-wrapper-pdp');
              if (addonCont) {
                // Add a tiny delay to ensure DOM is ready
                setTimeout(() => {
                  const headerOffset = document.querySelector('.header') ? document.querySelector('.header').offsetHeight : 0;
                  const elementPosition = addonCont.getBoundingClientRect().top;
                  const offsetPosition = elementPosition + window.scrollY - headerOffset - 20;
                  window.scrollTo({
                    top: offsetPosition,
                    behavior: "smooth"
                  });
                }, 100);
              }
              // ---------------------------------
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      showAddToCartPopup(cartData) {
        const popup = document.getElementById('add-to-cart-popup');
        if (!popup || !cartData) return;

        // Hide the default cart notification
        const cartNotification = document.querySelector('cart-notification');
        if (cartNotification) {
          const notification = cartNotification.querySelector('.cart-notification');
          if (notification) {
            notification.classList.remove('active');
            notification.setAttribute('aria-hidden', 'true');
          }
        }

        // The response from /cart/add.json IS the added item itself
        const addedItem = cartData;

        // Populate popup with item data
        const img = popup.querySelector('.add-to-cart-popup__img');

        if (img) {
          img.src = addedItem.featured_image?.url || addedItem.image || '';
          img.alt = addedItem.product_title || '';
        }
        // Show popup
        popup.hidden = false;
        setTimeout(() => popup.classList.add('show'), 10);

        // Setup close button if not already done
        const closeBtn = popup.querySelector('.popup-overlay');
        if (closeBtn && !closeBtn.dataset.listenerAdded) {
          closeBtn.addEventListener('click', () => {
            popup.classList.remove('show');
            setTimeout(() => popup.hidden = true, 300);
          });
          closeBtn.dataset.listenerAdded = 'true';
        }

        // Auto-hide after 3 seconds
        setTimeout(() => {
          popup.classList.remove('show');
          setTimeout(() => popup.hidden = true, 300);
        }, 2500);
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
